__turbopack_context__.v({
  "checkboxListWrap": "accordion-filter-module-scss-module__TURvqq__checkboxListWrap",
  "emptyMsg": "accordion-filter-module-scss-module__TURvqq__emptyMsg",
  "inner": "accordion-filter-module-scss-module__TURvqq__inner",
  "root": "accordion-filter-module-scss-module__TURvqq__root",
});
